import { useCallback, useEffect, useMemo, useState } from 'react';

import { Row, Col, FormGroup, Label, Switch } from 'twyne-new.ui';

import { TcpaQuestionCustomProvider } from './tabs'
import { getBlocksByType } from './tabs/TemplateBuilder/Builder/utils/blocksDefinition';
import compiler from './tabs/TemplateBuilder/Builder/utils/compiler';

export default function TcpaQuestionCustomForm({ integrationData: { extraFields: customFields, tcpaquestioncustom = {} } = {}, disabled, onChange, onCustomFieldClick, onChangeContent, onCompilerError, settings }) {
  const [customFieldsOptions, setCustomFieldsOptions] = useState([])
  const [customFieldSelected, setCustomFieldSelected] = useState({})
  const { templateType, blocks: blocksData } = tcpaquestioncustom

  useEffect(() => {
    if (!templateType) {
      onChange('templateType', 'button-and-dropdown')
    }
  }, [templateType, onChange])

  const { blocks } = useMemo(() => getBlocksByType(templateType || 'button-and-dropdown'), [templateType])

  useMemo(() => {
    blocks.forEach(block => compiler.updateBlockTemplate(block))
  }, [blocks])

  const updateContent = useCallback(async () => {
    if (!disabled) {
      const preCompilerContent = await compiler.preCompileTemplate([blocksData || {}]);
      const content = preCompilerContent.compile({});
      const hasError = content.includes("error on render tamplate block")
      onChangeContent(hasError ? "" : content)
      onCompilerError(content.includes("error on render tamplate block"))
    }
  }, [disabled, blocksData, onChangeContent, onCompilerError])

  useEffect(() => {
    updateContent()
  }, [tcpaquestioncustom.blocks, updateContent])

  useEffect(() => {
    setCustomFieldsOptions((customFields || []).map(({
      id, group, type, options, date_format, key: value, name: label,
    }) => ({
      id, group, type, options, date_format, value, label: `${label} (${type})`,
    })))
  }, [customFields])

  useEffect(() => {
    setCustomFieldSelected(customFieldsOptions.reduce((accumulator, currentField) => {
      if (currentField.value === tcpaquestioncustom.cfid) {
        return currentField
      }
      return accumulator
    }, {}))
  }, [customFieldsOptions, tcpaquestioncustom.cfid])

  useEffect(() => {
    updateOptions(customFieldSelected)
  }, [customFieldSelected])


  function insertAnswer(answers, answer) {
    answers.push(answer);
    return answers
  }

  function handleAddAnswer(answer) {
    onChange('answers', insertAnswer(tcpaquestioncustom.answers, answer))
  }

  function handleRemoveAnswers(idx) {
    const { answers } = tcpaquestioncustom
    answers.splice(idx, 1);
    onChange('answers', answers)
  }

  function updateOptions(customField) {
    if (!customField) return

    const isSelect = customField.type === 'select';
    const isBoolean = customField.type === 'boolean';

    if (isSelect) {
      const { answers } = tcpaquestioncustom
      const currentKeyAnswers = answers.map(({ key }) => key)
      const newKeysAnswers = customField.options.map(({ value: key }) => key)

      answers.forEach(({ key }, idx) => !newKeysAnswers.includes(key) && handleRemoveAnswers(idx))

      customField.options.forEach(({ value: key, label: answer }) => !currentKeyAnswers.includes(key) && handleAddAnswer({ key, answer }))
    }
    if (isBoolean) {
      const { answers } = tcpaquestioncustom;
      const options = [{ key: "true", answer: "Yes" }, { key: "false", answer: "No" }];
      const currentKeyAnswers = answers.map(({ key }) => key);
      answers.forEach(({ key }, idx) => {
        !["true", "false"].includes(key) && handleRemoveAnswers(idx)
      });
      options.forEach(({ key, answer }) => {
        !currentKeyAnswers.includes(key) && handleAddAnswer({ key, answer })
      });
      return;
    }
    tcpaquestioncustom.answers = tcpaquestioncustom.answers || [];
  }


  function handleCerts(attribute, checked) {
    if (checked) {
      if (!tcpaquestioncustom.cfid) return

      onChange(attribute, checked)
      onChange(`${attribute}_cfid`, `${tcpaquestioncustom.cfid}_${attribute}`)
    } else {
      onChange(attribute, false)
      onChange(`${attribute}_cfid`, '')
    }
  }

  function handleToggleOptions(attribute, checked) {
    switch (attribute) {
      case 'trustedform':
        handleCerts(attribute, checked)
        break;
      case 'leadid':
        handleCerts(attribute, checked)
        break;
      default:
        onChange(attribute, checked)
        break;
    }
  }


  return <div>
    <Row>
      {settings}
    </Row>
    <Row className='mt-4'>
      <Col size='2'>
        <FormGroup>
          <Label>Trusted Form?</Label>
          <Switch
            onChange={e => handleToggleOptions('trustedform', e.target.checked)}
            checked={tcpaquestioncustom.trustedform || false}
            disabled={disabled}
          />
        </FormGroup>
      </Col>
      <Col size='2'>
        <FormGroup>
          <Label>LeadId?</Label>
          <Switch
            onChange={e => handleToggleOptions('leadid', e.target.checked)}
            checked={tcpaquestioncustom.leadid || false}
            disabled={disabled}
          />
        </FormGroup>
      </Col>
      <Col size='2'>
        <FormGroup>
          <Label>Always Visible?</Label>
          <Switch
            onChange={e => handleToggleOptions('alwaysShow', e.target.checked)}
            checked={tcpaquestioncustom.alwaysShow || false}
          />
        </FormGroup>
      </Col>
      <Col size='2'>
        <FormGroup>
          <Label>Auto Scroll to Consent</Label>
          <Switch
            onChange={e => handleToggleOptions('autoScrollToConsent', e.target.checked)}
            checked={tcpaquestioncustom.autoScrollToConsent || false}
            disabled={disabled}
          />
        </FormGroup>
      </Col>
      <Col size='2'>
        <FormGroup>
          <Label>Save Consent Text</Label>
          <Switch
            onChange={e => handleToggleOptions('saveConsentText', e.target.checked)}
            checked={tcpaquestioncustom.saveConsentText || false}
            disabled={disabled}
          />
        </FormGroup>
      </Col>
      <TcpaQuestionCustomProvider />
    </Row>
  </div>
}
